const noProductsContainer = document.querySelector('atomic-commerce-no-products');
if (noProductsContainer) {
    const textOnBackgroundDiv = noProductsContainer.shadowRoot.querySelector('.text-on-background');
    if (textOnBackgroundDiv) {
        const viewToggleDiv = document.querySelector('.view-toggle');
        if (viewToggleDiv) {
        viewToggleDiv.style.display = 'none';
        }
    }
}